import { Icon } from "@bluframe/blublocks"
import theme from "styles/theme"

import { ComponentProps } from "."
import { Li, Link, Ul, Wrapper } from "./styled"
import SubItem from "./SubItem"

const Item = ({
  iconGroup,
  iconName,
  isAdmin,
  isEditor,
  isExpanded,
  isShowSubItems,
  isSocials,
  label,
  link,
  onSetOpenSubItems,
  subItems
}: ComponentProps) => (
  <Wrapper $isExpanded={isExpanded}>
    <Link onClick={onSetOpenSubItems} to={link ?? "#"}>
      <Icon
        color={theme.palette!.primary!.main}
        group={iconGroup}
        name={iconName}
        size="18px"
        title={label}
      />
    </Link>

    {isExpanded ? (
      <Link onClick={onSetOpenSubItems} to={link ?? "#"}>
        {label}
      </Link>
    ) : null}

    {subItems && isExpanded && isShowSubItems ? (
      <>
        <div />

        <Ul aria-label={`${label} Navigation Sub Items`}>
          {subItems
            .filter((item) => {
              if (isAdmin) {
                return true
              }

              if (isEditor && item.isEditor) {
                return true
              }

              if (isSocials && item.isSocials) {
                return true
              }

              return false
            })
            .map(({ isAdmin: __, ...subItem }) => (
              <Li aria-label={`${label} ${subItem.label}`} key={subItem.link}>
                <SubItem {...subItem} />
              </Li>
            ))}
        </Ul>
      </>
    ) : null}
  </Wrapper>
)

export default Item
